export default __webpack_public_path__ + "static/after-1-77be13a6cb9082865b82451c0ebf3575.png";